import { Loading } from "@/components/src/animations/loading";
import {
	JobDocumentEntityType,
	SupabaseTableEnum,
} from "../../../../lib/supabase/supabaseTypes";
import { Logger } from "@/lib/logger/Logger";
import { supabase } from "@/lib/supabase/supabaseClient";
import { useState, useEffect } from "react";
import { JobItemComponent } from "../../pages/Jobs/job-item.component";
import { showNotification } from "../../store/Central/selectors";
import { useJobStore } from "../../store/Job";
import { JobDocumentTypeEnum } from "@/dentlab/src/pages/job-page/job-document/job-document.types";
import { JobStatusEnum } from "@/lib/types/job";

export const DocumentSelectionComponent = ({
	handleSelect,
	setLoading,
	loading,
	jobId,
	clientId,
}: {
	handleSelect: (jobDocument: JobDocumentEntityType) => void;
	setLoading: (loading: boolean) => void;
	loading: boolean;
	jobId: string;
	clientId: string;
}) => {
	const [jobDocuments, setJobDocuments] = useState<JobDocumentEntityType[]>(
		[]
	);
	const { createJobDocument } = useJobStore();

	const getJobDocuments = async () => {
		setLoading(true);
		const { data: jobData, error: jobError } = await supabase
			.from(SupabaseTableEnum.JOBS)
			.select("*")
			.eq("id", Number(jobId))
			.single();

		if (jobError) {
			Logger.error(jobError, {}, "Error fetching job");
		}

		if (jobData && jobData.status === JobStatusEnum.COMPLETED) {
			showNotification({
				message: "Auftrag ist bereits abgeschlossen",
				type: "error",
			});
			setLoading(false);
			return;
		}

		const { data, error } = await supabase
			.from("job_documents")
			.select("*")
			.eq("job_id", Number(jobId))
			.is("deleted_at",null);
		if (error) {
			Logger.error(error, {}, "Error fetching job documents");
			showNotification({
				message: "Fehler beim Laden der Dokumente",
				type: "error",
			});
		}
		setJobDocuments(data as JobDocumentEntityType[]);
		setLoading(false);
	};

	const handleCreateDeliveryNote = async () => {
		const jobDocument = await createJobDocument(
			Number(jobId),
			clientId,
			JobDocumentTypeEnum.DeliveryNote
		);
		if (jobDocument) {
			handleSelect(jobDocument);
		}
	};

	useEffect(() => {
		getJobDocuments();
	}, [jobId]);

	return (
		<div className="h-full flex flex-col overflow-hidden">
			<div className="flex-1 overflow-y-auto">
				<div className="flex flex-col gap-2">
					{loading ? (
						<div className="mt-8">
							<Loading />
						</div>
					) : (
						<>
							
								{!jobDocuments.find(
									(jobDocument) =>
										jobDocument.type ===
										JobDocumentTypeEnum.DeliveryNote
								) && (
									<div className="flex flex-col gap-2 mb-4">
										<div className="text-lg font-bold">
											Dokument erstellen
										</div>
										<div
											onClick={handleCreateDeliveryNote}
											className="p-2 bg-green-100 rounded cursor-pointer transition-colors active:bg-blue-200"
										>
											<div className="text-lg">
												Lieferschein erstellen
											</div>
										</div>
										</div>
								)}
							
							{jobDocuments.length > 0 && (
								<div className="flex flex-col gap-2">
									<div className="text-lg font-bold">
										Vorhandene Dokumente
									</div>
									{jobDocuments?.map((jobDocument) => (
										<JobItemComponent
											key={jobDocument.id}
											jobTitle={jobDocument.title ?? ""}
											jobCode={jobDocument.code ?? ""}
											onSelect={() =>
												handleSelect(jobDocument)
											}
										/>
									))}
								</div>
							)}
						</>
					)}
				</div>
			</div>
		</div>
	);
};
